import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17a4d614"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dictionary section-type-selector" }
const _hoisted_2 = { class: "card bg-light mb-3" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = {
  key: 0,
  class: "col-3"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Section", -1))
const _hoisted_7 = {
  key: 1,
  class: "col-3"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-outline-secondary float-right",
  "data-toggle": "modal",
  "data-target": "#dictionary-types-modal"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h" })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Type", -1))
const _hoisted_10 = {
  key: 2,
  class: "col-6"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-outline-secondary float-right",
  "data-toggle": "modal",
  "data-target": "#dictionary-items-modal"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h" })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Item", -1))

import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import DictionaryTypesModal from '@/components/modals/DictionaryTypesModal.vue';
import DictionaryItemsModal from '@/components/modals/DictionaryItemsModal.vue';

// Models can remain the same
import { DictionarySection, DictionaryType, DictionaryItem } from '@/models';
import { DictionaryState } from '@/store/dictionary/types';

// Define props with type annotations

export default /*#__PURE__*/_defineComponent({
  __name: 'SectionTypeSelector',
  props: {
    showSections: { type: Boolean },
    showTypes: { type: Boolean },
    showItems: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const store = useStore();

// Computed properties for getting state values
const dictionaryState = computed(() => store.state.dictionary as DictionaryState);

// Computed properties with getters and setters for activeSection, activeType, and activeItem
const activeSection = computed<DictionarySection>({
  get: () => dictionaryState.value.activeSection,
  set: (val: DictionarySection) => {
    store.commit('dictionary/setActiveSection', val);
    unsetActiveType();
  },
});

const activeType = computed<DictionaryType>({
  get: () => dictionaryState.value.activeType,
  set: (val: DictionaryType) => {
    store.commit('dictionary/setActiveType', val);
    unsetActiveItem();
  },
});

const activeItem = computed<DictionaryItem>({
  get: () => dictionaryState.value.activeItem,
  set: (val: DictionaryItem) => {
    store.commit('dictionary/setActiveItem', val);
  },
});

// Methods are simply converted to functions
function unsetActiveSection() {
  store.commit('dictionary/setActiveSection', new DictionarySection());
  unsetActiveType();
}

function unsetActiveType() {
  store.commit('dictionary/setActiveType', new DictionaryType());
  unsetActiveItem();
}

function unsetActiveItem() {
  store.commit('dictionary/setActiveItem', new DictionaryItem());
}

function getSystemName(type: DictionaryType): string {
  return type.getSystemName();
}

// Computed properties for the getters
const allSections = computed(() => store.getters['dictionary/allSections'] as DictionarySection[]);
const currentTypes = computed(() => store.getters['dictionary/currentTypes'] as DictionaryType[]);
const currentItems = computed(() => store.getters['dictionary/currentItems'] as DictionaryItem[]);

const hasActiveSection = computed(() => store.getters['dictionary/hasActiveSection'] as boolean);
const hasActiveType = computed(() => store.getters['dictionary/hasActiveType'] as boolean);
const hasActiveItem = computed(() => store.getters['dictionary/hasActiveItem'] as boolean);


return (_ctx: any,_cache: any) => {
  const _component_multiselect = _resolveComponent("multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.showSections)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_multiselect, {
                  modelValue: activeSection.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeSection).value = $event)),
                  "track-by": "slug",
                  options: allSections.value
                }, null, 8, ["modelValue", "options"]),
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-link pb-0", {'text-muted': !hasActiveSection.value}]),
                  onClick: unsetActiveSection
                }, " Clear ", 2)
              ]))
            : _createCommentVNode("", true),
          (_ctx.showTypes && hasActiveSection.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _hoisted_9,
                _createVNode(_component_multiselect, {
                  modelValue: activeType.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeType).value = $event)),
                  "track-by": "slug",
                  "custom-label": getSystemName,
                  options: currentTypes.value
                }, null, 8, ["modelValue", "options"]),
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-link pb-0", {'text-muted': !hasActiveType.value}]),
                  onClick: unsetActiveType
                }, " Clear ", 2)
              ]))
            : _createCommentVNode("", true),
          (_ctx.showItems && hasActiveType.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _hoisted_12,
                _createVNode(_component_multiselect, {
                  modelValue: activeItem.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeItem).value = $event)),
                  "track-by": "slug",
                  options: currentItems.value
                }, null, 8, ["modelValue", "options"]),
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-link pb-0", {'text-muted': !hasActiveItem.value}]),
                  onClick: unsetActiveItem
                }, " Clear ", 2)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(DictionaryTypesModal),
    _createVNode(DictionaryItemsModal)
  ]))
}
}

})